import { render, staticRenderFns } from "./Union.vue?vue&type=template&id=4da90563&scoped=true&"
import script from "./Union.vue?vue&type=script&lang=js&"
export * from "./Union.vue?vue&type=script&lang=js&"
import style0 from "./Union.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Union.vue?vue&type=style&index=1&id=4da90563&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da90563",
  null
  
)

export default component.exports